/* eslint-disable sort-keys */
export default {
    Popover: {
        parts: [
            "content",
            "popper",
            "header",
            "body",
            "footer",
            "arrow"
        ],
        baseStyle: {},
        variants: {
            deafult: {
                popper: {
                    maxWidth: "sm",
                },
                content: {
                    border: "0",
                    maxWidth: "sm",
                    _focus: {
                        boxShadow: "none"
                    }
                }
            }
        },
        sizes: {},
        defaultProps: {
            variant: "deafult"
        }
    }
};
